<div class="row">
  <div class="col">
    <div>{{ address.FirstName }} {{ address.LastName }}</div>
  </div>
</div>
<div class="row" *ngIf="address.Company">
  <div class="col">{{ address.Company }}</div>
</div>
<div class="row">
  <div class="col">{{ address.Address_ }}</div>
</div>
<div class="row">
  <div class="col">{{ address.Address2 }}</div>
</div>
<div class="row">
  <div class="col">{{ address.City }} {{ address.StateProvinceName }}</div>
</div>
<div class="row">
  <div class="col">{{ address.PostalCodeZip }}</div>
</div>
<div class="row">
  <div class="col">{{ address.CountryName }}</div>
</div>
